{
  "pages": {
    "CustomerDetail": {
      "all_customers": "All customers",
      "status": "Status:",
      "edit_customer": "Edit customer",
      "details": "Details",
      "edit": "Edit",
      "email": "Email",
      "phone": "Phone",
      "address": "Address",
      "customer_since": "Customer since",
      "summary": "Summary",
      "total_spent": "Total Spent",
      "usd": "MYR",
      "total_invoices": "Total Invoices",
      "avg_invoice_value": "Avg. Invoice Value",
      "payment_methods": "Payment methods",
      "add_card": "Add card",
      "default": "Default",
      "expires": "Expires",
      "set_as_default": "Set as Default",
      "no_payment_methods_stored": "No payment methods stored",
      "invoices": "Invoices",
      "transactions": "Transactions",
      "invoice": "Invoice",
      "date": "Date",
      "due_date": "Due Date",
      "amount": "Amount",
      "status_2": "Status",
      "description": "Description",
      "payment_method": "Payment Method",
      "view_invoice": "View Invoice",
      "history": "History"
    },
    "CustomerForm": {
      "back_to_customers": "Back to Customers",
      "customer_information": "Customer Information",
      "company": "Company",
      "individual": "Individual",
      "company_name": "Company Name *",
      "attrs": {
        "enter_company_name": "Enter company name",
        "enter_contact_person": "Enter contact person",
        "13digit_registration_number": "13-digit registration number",
        "enter_full_name": "Enter full name",
        "billingcompanycom": "billing@company.com",
        "123_business_street": "123 Business Street",
        "suite_building_floor_etc": "Suite, building, floor, etc.",
        "bangkok": "Kuala Lumpur",
        "add_any_internal_notes_about_this": "Add any internal notes about this customer"
      },
      "contact_person": "Contact Person",
      "tax_id_registration_number": "Tax ID / Registration Number",
      "full_name": "Full Name *",
      "email_address": "Email Address *",
      "phone_number": "Phone Number",
      "billing_information": "Billing information",
      "address_line_1": "Address Line 1",
      "address_line_2": "Address Line 2",
      "city": "City",
      "province": "Province",
      "country": "Country",
      "thailand": "Malaysia",
      "postcode": "Postcode",
      "additional_information": "Additional information",
      "internal_notes": "Internal Notes",
      "active": "Active",
      "inactive": "Inactive",
      "cancel": "Cancel"
    },
    "Customers": {
      "customers": "Customers",
      "add_customer": "Add customer",
      "total_customers": "Total Customers",
      "active_customers": "Active Customers",
      "total_revenue": "Total Revenue",
      "avg_revenuecustomer": "Avg. Revenue/Customer",
      "all": "All",
      "attrs": {
        "search_by_customer": "Search by customer"
      },
      "customer": "Customer",
      "contact": "Contact",
      "location": "Location",
      "since": "Since",
      "no_customers_found_matching_your_criteria": "No customers found matching your criteria."
    }
  }
}
